import React, { ReactNode } from "react";
import { Box, Grid2, Typography, useTheme } from "@mui/material";

export type InfoRowProps = {
  label: ReactNode | string;
  value1?: ReactNode;
  value2?: ReactNode;
  withTopBorder?: boolean;
};

export const InfoRow = ({
  label,
  value1,
  value2,
  withTopBorder,
}: InfoRowProps) => {
  const theme = useTheme();

  return (
    <Grid2
      container
      alignItems="center"
      spacing={2}
      sx={{
        py: 3,
        minHeight: "54px",
        borderTop: withTopBorder
          ? `1px solid ${theme.palette.border.secondary}`
          : "none",
      }}
    >
      <Grid2
        size={{ xs: 0, md: 4 }}
        sx={{ display: { xs: "none", md: "block" } }}
      >
        <Box ml={3}>
          {typeof label === "string" ? (
            <Typography variant="body2" color="textSecondary" pr={4}>
              {label}
            </Typography>
          ) : (
            label
          )}
        </Box>
      </Grid2>
      <Grid2 size={{ xs: 6, md: 4 }}>
        {typeof value1 === "string" ? (
          <Typography variant="body4">{value1}</Typography>
        ) : (
          value1
        )}
      </Grid2>
      <Grid2 size={{ xs: 6, md: 4 }}>
        {typeof value2 === "string" ? (
          <Typography variant="body4">{value2}</Typography>
        ) : (
          value2
        )}
      </Grid2>
    </Grid2>
  );
};
